import { baseUrl } from '@/config'
import request from '@/axios'

export function fetchModelTree() {
  return request({
    url: baseUrl+'/adm/meta_model_group/tree',
    method: 'get',
  })
}

export function addModelObj(data){
  return request({
    url: baseUrl+"/adm/meta_model",
    method:'post',
    params:data
  })
  
}

export function editModelObj(data){
  return request({
    url: baseUrl+"/adm/meta_model/edit",
    method:'post',
    params:data
  })
  
}

// 获取模型详情
export function getModelDetail(id)  {
  return request({
    url: baseUrl+`/adm/meta_model/${id}`,
    method: 'get'
  })
}

export function exchangeModelSort(data){
  return request({
    url: baseUrl+"/adm/meta_model/exchange_sort",
    method:'post',
    params:data
  })
  
}

export function exchangeModelGroupSort(data) {
  return request({
    url: baseUrl+'/adm/meta_model_group/exchange_sort',
    method: 'post',
    params:data
  })
}

// 删除模型
export const deleteModel = (id) => {
  return request({
    url: baseUrl+`/adm/meta_model/${id}`,
    method: 'post'
  })
}
//分组详情
export const getModelGroupDetail = (id) => {
  return request({
    url: baseUrl+`/adm/meta_model_group/${id}`,
    method: 'get'
  })
}
//禁用模型
export function  editModelDisabled(data)  {
  return request({
  url: baseUrl+'/adm/meta_model/edit_disable',
  method: 'post',
  params: data
  })
}

// 添加分组
export function addModelGroup (data) {
  return request({
  url: baseUrl+'/adm/meta_model_group',
  method: 'post',
  params: data
  })
}

// 编辑分组
export function editModelGroup (data) {
  return request({
  url: baseUrl+'/adm/meta_model_group/edit',
  method: 'post',
  params: data
  })
}
// 禁用/启用分组
export function editModelGroupDisabled (data) {
  return request({
  url: baseUrl+'/adm/meta_model_group/edit_disable',
  method: 'post',
  params: data
  })
}

// 删除分组
export const deleteModelGroup = (id) => {
  return request({
    url: baseUrl+`/adm/meta_model_group/${id}`,
    method: 'delete'
  })
}

// 导入数据
export function importModelData (data){
  return request({
    url: baseUrl+'/adm/meta_model/import_meta_model',
    method: 'post',
    data:data
  })
}


// 数据字段列表
export function getModelFieldList(data) {
  return request({
  url: baseUrl+'/adm/meta_model_field/list',
  method: 'get',
  params:data
  })
}

// 获取数据字段详情
export function  getDataFieldDetail (id) {
  return request({
    url: baseUrl + `/adm/meta_model_field/${id}`,
    method: 'get'
  })
}

// 添加模型字段
export function  addModelField (data) {
  return request({
    url: baseUrl + '/adm/meta_model_field',
    method: 'post',
    params:data
  })
}
// 编辑模型字段
export function editModelField (data) {
  return request({
    url: baseUrl + '/adm/meta_model_field/edit',
    method: 'post',
    params:data
  })
}

// 调整模型字段顺序
export function exchangeModelFieldSort (data) {
  return request({
    url: baseUrl + '/adm/meta_model_field/exchange_sort',
    method: 'post',
    params:data

  })
}

// 删除数据字段
export function deleteField (id) {
  return request({
    url: baseUrl + `/adm/meta_model_field/${id}`,
    method: 'delete'
  })
}